module.exports = __webpack_public_path__ + "static/edit_content-70b7870382156b83385ef7c87ac9738b.webp";